import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import style from './SideBannerComp.module.css';
import homeIcon from '../../assets/images/common/homeIcon.png'
import arrow from '../../assets/images/common/arrow.png'
import { isMobile } from '../../config';

const SideBannerComp = ({ pageKey }) => {
  const sideBannerData = require('./SideBannerData').default;
  const [idx, setIdx] = useState(0);

  const { title, links } = sideBannerData[pageKey];
  const sub = idx !== null ? links[idx].sub : null;

  const location = useLocation();
  const currentPathname = location.pathname;

  useEffect(() => {
    const foundIndex = sideBannerData[pageKey].links.findIndex(item => currentPathname.includes(item.link.replace(/\/\d+$/, '')));
    setIdx(foundIndex);
  }, []);

  return (
    <>
    {isMobile() ? (
      <>
        <div className='prod-line-detail'></div>
        {currentPathname.includes('portfolio/partner/detail') ? '' : (
          <div className={style.subectText}>
            {title + ' - ' + sub}
          </div>
        )}
      </>
    ) : (
      <>
        <div className={style.componentsDiv} draggable>
          <div className={style.components}>
            <p className={style.title}>{title}</p>
            <ul className={style.subDiv}>
              {links.map((linkData, index) => (
                <li key={index} className={style.subList}>
                  <Link
                    to={linkData.link}
                    className={currentPathname.includes(linkData.link) ? style.activeLink : ''}
                    onClick={(e)=>{
                      if(currentPathname === linkData.link){
                        e.preventDefault();
                        window.location.reload();
                      }
                    }}
                  >
                    {linkData.sub}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className={style.subjectDiv}>
          <div>
            <img src={homeIcon} alt='home'/>
            <img src={arrow} alt='>' className={style.arrow}/>
            {title}
            <img src={arrow} alt='>' className={style.arrow}/>
            {sub}
          </div>
          {currentPathname.includes('portfolio/partner/detail') ? '' : (
            <div className={style.subectText}>
              {title + ' - ' + sub}
            </div>
          )}
        </div>
      </>
    )}
    </>
  );
};

SideBannerComp.propTypes = {
  pageKey: PropTypes.string.isRequired,
};

export default SideBannerComp;